/**
 * Rengin açık mı koyu mu olduğunu kontrol eder
 * @param {string} color - Kontrol edilecek renk (hex kodu)
 * @returns {boolean} - Renk açık ise true, koyu ise false
 */
export const isColorLight = (color) => {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return brightness > 155;
};

/**
 * Rengi belirtilen faktör kadar açar
 * @param {string} color - Açılacak renk (hex kodu)
 * @param {number} factor - Açma faktörü (0-1 arası)
 * @returns {string} - Açılmış renk (hex kodu)
 */
export const lightenColor = (color, factor) => {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  const lightenChannel = (channel) => {
    const lightened = Math.round(channel + (255 - channel) * factor);
    return Math.min(255, Math.max(0, lightened));
  };
  
  const rr = lightenChannel(r).toString(16).padStart(2, '0');
  const gg = lightenChannel(g).toString(16).padStart(2, '0');
  const bb = lightenChannel(b).toString(16).padStart(2, '0');
  
  return `#${rr}${gg}${bb}`;
};

/**
 * Metrik ID'sine göre özel renk ataması yapar
 * @param {number} metricId - Metrik ID'si
 * @param {number} value - Metrik değeri
 * @returns {object} - {backgroundColor, color, fontWeight} şeklinde stil nesnesi
 */
export const getMetricColorStyle = (metricId, value, allMetricsData, brandId) => {
  // Özel renklendirilecek metrik ID'leri
  const specialMetricIds = [10010, 10062, 10012, 10064, 10013, 10048, 10063];
  
  if (specialMetricIds.includes(metricId)) {
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return {};
    
    // 10063 metriği için 10055 ile karşılaştırma yap
    if (metricId === 10063 && allMetricsData && brandId) {
      const compareMetric = allMetricsData[brandId]?.allMetrics?.find(m => m.id === 10055);
      if (compareMetric) {
        const compareValue = parseFloat(compareMetric.value);
        if (!isNaN(compareValue)) {
          return {
            backgroundColor: numValue < compareValue ? 'rgba(107, 114, 128, 0.7)' : '#22c55e',
            color: '#fff',
            fontWeight: 'bold'
          };
        }
      }
    }
    
    // Diğer metrikler için varsayılan mantık (negatif/pozitif kontrolü)
    return {
      backgroundColor: numValue < 0 ? 'rgba(107, 114, 128, 0.7)' : '#22c55e',
      color: '#fff',
      fontWeight: 'bold'
    };
  }
  
  return {};
}; 